import { render } from "./DashboardMessageNotification.vue?vue&type=template&id=1e808162"
import script from "./DashboardMessageNotification.vue?vue&type=script&lang=js"
export * from "./DashboardMessageNotification.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Programs\\Projects\\www\\cae-new-web\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"DashboardMessageNotification.vue"]])

export default __exports__